import React from 'react';
import { Node } from '../models/common/Node';
import { FormattedMessage } from 'react-intl';
import { UserStatus } from '../enums/UserStatus';
import { RoleType } from '../enums/RoleType';

export const getStatusNodes = (): Node[] => [{
  value: UserStatus.Active,
  label: <FormattedMessage id="active" defaultMessage="Active" />
}, {
  value: UserStatus.Inactive,
  label: <FormattedMessage id="inactive" defaultMessage="Inactive" />
}];

export const getRoleNodes = () => [{
  value: RoleType.User,
  label: { id: 'user', defaultMessage: 'User' }
}, {
  value: RoleType.WorkspaceAdmin,
  label: { id: 'admin', defaultMessage: 'Admin' }
}];
